import {Component, OnInit, ViewChild} from '@angular/core';
import {Http} from '@angular/http';
import {DataSource} from '@angular/cdk/collections';
import {MdPaginator, MdSort} from '@angular/material';
import {Observable} from 'rxjs/Observable';
import'rxjs/add/observable/merge';
import'rxjs/add/observable/of';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/map';
import'rxjs/add/operator/startWith';
import'rxjs/add/operator/switchMap';
/**
 * \@title Table retrieving data through HTTP
 */
export class TableHttpExample implements OnInit {
  displayedColumns = ['created_at', 'state', 'number', 'title'];
  exampleDatabase: ExampleHttpDao | null;
  dataSource: ExampleDataSource | null;

   paginator: MdPaginator;
   sort: MdSort;
/**
 * @param {?} http
 */
constructor(private http: Http) {}
/**
 * @return {?}
 */
ngOnInit() {
    this.exampleDatabase = new ExampleHttpDao(this.http);
    this.dataSource = new ExampleDataSource( /** @type {?} */((
      this.exampleDatabase)), this.paginator, this.sort);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'table-http-example',
  styleUrls: ['table-http-example.css'],
  templateUrl: 'table-http-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'paginator': [{ type: ViewChild, args: [MdPaginator, ] },],
'sort': [{ type: ViewChild, args: [MdSort, ] },],
};
}

function TableHttpExample_tsickle_Closure_declarations() {
/** @type {?} */
TableHttpExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TableHttpExample.ctorParameters;
/** @type {?} */
TableHttpExample.propDecorators;
/** @type {?} */
TableHttpExample.prototype.displayedColumns;
/** @type {?} */
TableHttpExample.prototype.exampleDatabase;
/** @type {?} */
TableHttpExample.prototype.dataSource;
/** @type {?} */
TableHttpExample.prototype.paginator;
/** @type {?} */
TableHttpExample.prototype.sort;
/** @type {?} */
TableHttpExample.prototype.http;
}


export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}
/**
 * An example database that the data source uses to retrieve data for the table.
 */
export class ExampleHttpDao {
/**
 * @param {?} http
 */
constructor(private http: Http) {}
/**
 * @param {?} sort
 * @param {?} order
 * @param {?} page
 * @return {?}
 */
getRepoIssues(sort: string, order: string, page: number): Observable<GithubApi> {
    const /** @type {?} */ href = 'https://api.github.com/search/issues';
    const /** @type {?} */ requestUrl =
      `${href}?q=repo:angular/material2&sort=${sort}&order=${order}&page=${page + 1}`;

    return this.http.get(requestUrl)
                    .map(response => /** @type {?} */(( response.json() as GithubApi)));
  }
}

function ExampleHttpDao_tsickle_Closure_declarations() {
/** @type {?} */
ExampleHttpDao.prototype.http;
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleHttpDao. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class ExampleDataSource extends DataSource<GithubIssue> {
  // The number of issues returned by github matching the query.
  resultsLength = 0;
  isLoadingResults = false;
  isRateLimitReached = false;
/**
 * @param {?} exampleDatabase
 * @param {?} paginator
 * @param {?} sort
 */
constructor(private exampleDatabase: ExampleHttpDao,
private paginator: MdPaginator,
private sort: MdSort) {
    super();
  }
/**
 * Connect function called by the table to retrieve one stream containing the data to render.
 * @return {?}
 */
connect(): Observable<GithubIssue[]> {
    const /** @type {?} */ displayDataChanges = [
      this.sort.sortChange,
      this.paginator.page
    ];

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    return Observable.merge(...displayDataChanges)
      .startWith(null)
      .switchMap(() => {
        this.isLoadingResults = true;
        return this.exampleDatabase.getRepoIssues(
          this.sort.active, this.sort.direction, this.paginator.pageIndex);
      })
      .map(data => {
        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
        this.resultsLength = data.total_count;

        return data.items;
      })
      .catch(() => {
        this.isLoadingResults = false;
        // Catch if the GitHub API has reached its rate limit. Return empty data.
        this.isRateLimitReached = true;
        return Observable.of([]);
      });
  }
/**
 * @return {?}
 */
disconnect() {}
}

function ExampleDataSource_tsickle_Closure_declarations() {
/** @type {?} */
ExampleDataSource.prototype.resultsLength;
/** @type {?} */
ExampleDataSource.prototype.isLoadingResults;
/** @type {?} */
ExampleDataSource.prototype.isRateLimitReached;
/** @type {?} */
ExampleDataSource.prototype.exampleDatabase;
/** @type {?} */
ExampleDataSource.prototype.paginator;
/** @type {?} */
ExampleDataSource.prototype.sort;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
